import ApiService from '../services/ApiService';
import ApiConstants from '../services/ApiConstants';
import helperSession from '../helpers/HelperSession';

const UserAccessHandler = {

    oApi: new ApiService(),
    
    getUserAccessData(access_code) {
        const urlParams = {};
        const headers = {};

        return new Promise((resolve, reject) => {
            if(helperSession.air_mode){
                urlParams.AIR_access_code = access_code;
                headers.plant_code = helperSession.plant_code;
            } else {
                urlParams.code = access_code;
                urlParams.redirect_uri = process.env.REACT_APP_REDIRECT_URL;                
            }           

            this.oApi.GET(ApiConstants.User.Controller, ApiConstants.User.Token, urlParams, headers)
            .then(response => {                
                helperSession.access_token = response.data.access_token;

                const entitlements = [];                
                response.data.user_profile.entitlements.forEach(x => {
                    console.log("*** Entitlement: ", x);
                    // Flexible regex: matches "Molex CCS SPC Tool" or "molex_ccs_spc_tool" with any spacing around the dash
                    const match = x.match(/^molex[_ ]ccs[_ ]spc[_ ]tool\s*[-–—]\s*(.+)$/i);
                    if (match) {
                        entitlements.push(match[1].toLowerCase().trim());
                    }
                    // Legacy format: "role=system_admin,source=identitynow,app=molex ccs spc tool"
                    else if (x.includes(',') && x.includes('molex ccs spc tool')) {
                        const attrs = x.split(',');
                        if (attrs[2] && attrs[2].split('=')[1] === 'molex ccs spc tool') {
                            entitlements.push(attrs[0].split('=')[1]);
                        }
                    }
                });
                response.data.user_profile.entitlements = entitlements;

                helperSession.profile = response.data.user_profile;

                helperSession.removeAppSession('access_code');
                resolve(response.data)
                //history.push('/');
            }).catch(error => {
                helperSession.removeAppSession('access_code');                
                console.error(error);
                reject(error);
            });
        });
    },

    
}

export default UserAccessHandler;